import { Collapse } from "bootstrap";

export default class SelectCollapse extends HTMLSelectElement {


    connectedCallback() {

        this.addEventListener('change', this.handleChange);
        
    }

    disconnectedCallback() {

        this.removeEventListener('change', this.handleChange);

    }

    get collapseTarget() {
        return document.querySelector(`#${this.getAttribute("aria-controls")}`);
    }

    get ShowValues() {
        return this.dataset.showValues.split(",").map(val => val.trim());
    }

    handleChange = e => {

        if (this.ShowValues.includes(this.value)) {
            new Collapse(this.collapseTarget, {
                show: true
            });
        }
        else {
            new Collapse(this.collapseTarget, {
                hide: true
            });
        }

    }

}

customElements.define('select-collapse', SelectCollapse, { extends: 'select' });